import { useState, useEffect  } from 'react'

const FieldInstances = props => {

  let fieldDefs = props.fieldDefs;
  if( props.data && 'function' === typeof props.fieldDefs) {
    fieldDefs = fieldDefs(props.data.getValue);
  }

  let fieldValues = props.value || {};
  if( !fieldValues._values) fieldValues._values = {};

  //for previous saved values
  const fieldDefinitions = []
  const tempObject = { _values: {} }

  tangibleFields.event('valueChange', (field) => {
    const fieldNames = fieldDefinitions.map((tField)=> tField.name )

    if(!fieldNames.includes(field.name)) return

    let fieldName = field.name,
      fieldValue = field.value,
      innerValues = tempObject['_values'][fieldName];

    tempObject[fieldName] = fieldValue

    innerValues.value = fieldValue
    if( innerValues.display_value ) { // Either select or something different
      if( 'select' === field.props.type ) {
        innerValues.display_value = innerValues.options[ fieldValue ];
      }
    }
  })

  fieldDefs.map((fieldObject, idx) => {

    const fieldItemType = fieldObject.type;
    if( !fieldItemType ) return

    //should we add to the backend-what's the name so that we don't use this?
    const fieldLabel = fieldObject.label,
      fieldName = fieldObject.name,
      defaultValue = fieldObject.default_value;

    let subField
    switch( fieldItemType ){
      case 'text':
        subField = {
          type: 'text',
          name: fieldName,
          label: fieldLabel,
        }

        tempObject[fieldName] = fieldObject.default_value;
        tempObject['_values'] = {...tempObject['_values'],
        [fieldName]:{
          value: defaultValue,
          name: fieldName,
          label: fieldLabel
        }
      }

        break;
      case 'number':
        subField = {
          type: 'number',
          name:  fieldName,
          label: fieldLabel,
        }

        tempObject[fieldName] = fieldObject.default_value;
        tempObject['_values'] = {...tempObject['_values'],
          [fieldName]:{
            value: defaultValue,
            name: fieldName,
            label: fieldLabel
          }
        }

        break;
      case 'select':
        let options = fieldObject.options

        subField = {
          type: 'select',
          name:  fieldName,
          label: fieldLabel,
          choices: options
        }

        tempObject[fieldName] = fieldObject.default_value;
        tempObject['_values'] = {...tempObject['_values'],
          [fieldName]:{
            name: fieldName,
            label: fieldLabel,
            value: defaultValue,
            options: options,
            display_value: options[defaultValue]
          }
        }
        break;
    }
    fieldDefinitions.push(subField)
  })

  let fieldValueKeys = Object.keys( fieldValues?._values?? {} ),
    fieldDefKeys = Object.keys ( tempObject._values),
    allFieldKeys = [...new Set(fieldValueKeys.concat(fieldDefKeys))];

  for( const key of allFieldKeys ) {
    if( !fieldValueKeys.includes(key) ) { // Missing in accreditation, pad up with agency defaults
      fieldValues._values[key] = tempObject._values[key]
      fieldValues[key] = tempObject[key]
    } else if( !fieldDefKeys.includes(key) ) { // Missing in agency, delete from accreditation
      // delete fieldValues._values[key]
      // delete fieldValues[key]
    }
  }

  const fieldsGroup = tangibleFields.render({
    type: 'field-group',
    name: props.name ?? 'agency_fields',
    value: fieldValues,
    fields: fieldDefinitions,
    onChange: props.onChange
  })

  return (
    <>
      <div className="tgbl-accreditation-fields tgbl-field-block" style={ fieldDefs.length === 0 ? {border: '1px dashed black', padding: '10px'}: {}}>
        <div className="tf-pseudo-label">{props.title ?? 'Accreditation Fields'} {fieldDefs.length === 0 && ' (none defined)'}</div>
        <div className="tf-pseudo-description">{props.description ?? 'These fields can be edited on Accrediting Agency.'}</div>
      </div>
      { fieldsGroup }
    </>
  )
}

export { FieldInstances }
